import React         from 'react';
import Cart          from 'pu-react/components/ProductCartForm';

export default (props) => {
  const { cart } = props;
  const unitPrice = cart.get('unit_price') || '';
  const totalPrice = cart.get('total_price') || '';
  const leadTime = cart.get('lead_time') || '';

  const onChangeQuantity = e => props.onChangeParameter('quantities', [e.target.value]);
  const parametersQuantity = props.parameters.getIn(['quantities', 0]);
  const properties = [
    { label: 'Quantity:', value: <input type="number" onChange={onChangeQuantity} value={parametersQuantity || ''} className="form-control product-qty" min="1" /> },
    { label: 'Lead Time:', value: (leadTime ? `${leadTime} days` : '24 to 48 Hours') },
  ];

  return (
    <div>
      <Cart
        quoteStep={props.quoteStep}
        properties={properties}
        unitPrice={unitPrice}
        totalPrice={totalPrice}
        parametersChanged={false}
        usePriceMatrix={false} />
    </div>
  );
};
